import { AfterViewInit,
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    Inject,
    OnDestroy,
    Output } from '@angular/core'

interface OffClickListener {
    element: Element;
    handler: EventEmitter<void>;
}

@Directive({
    selector: '[offClick]',
})
export class OffClickDirective implements AfterViewInit, OnDestroy {

    private static id = 0
    private static listeners: {[key: string]: OffClickListener} = {}

    @Output('offClick') offClick = new EventEmitter<void>()

    private element: Element
    private elementId: number

    constructor(@Inject(ElementRef) private elementRef: ElementRef) {
    }

    ngAfterViewInit(): void {
        this.element = this.elementRef.nativeElement
        this.elementId = OffClickDirective.id++

        OffClickDirective.listeners[this.elementId] = {
            element: this.element,
            handler: this.offClick,
        }
    }

    ngOnDestroy() {
        delete OffClickDirective.listeners[this.elementId]
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    @HostListener('document:click', ['$event'])
    private offClickHandler(event: Event): void {
        const target: any = event.target

        Object.entries(OffClickDirective.listeners).forEach((entry: [string, OffClickListener]) => {
            const listener: OffClickListener = entry[1]
            const element: Element = listener.element

            // Prevent offClick directive breaking opened modal with focused input afterViewInit
            const skipId = (event.target as HTMLElement).getAttribute('skipFor')
            if (skipId && skipId === element.id) {
                return
            }

            if (!(element.contains(target))) {
                setTimeout(() => {
                    listener.handler.emit()
                })
            }
        })
    }
}